import { Content, NoResultsIcon, Wrapper } from "./styled";

export const NoResults = () => (
    <Wrapper>
        <Content>
            <NoResultsIcon />
        </Content>
    </Wrapper>
);